module.exports = __webpack_public_path__ + "img/icon-rechnung.46d5b8d3.svg";